module.exports = __webpack_public_path__ + "img/defi.188a6c06.png";